import { Box, Button } from '@mui/material'
import type React from 'react'
import { useAuth } from '../hooks/useAuth'

type DownloadButtonProps = {
  title: string
  onClick: () => void
}

export const DownloadButton: React.FC<DownloadButtonProps> = props => {
  const auth = useAuth()
  return (
    <>
      <Box display="flex" justifyContent="center" mt={2} mb={2}>
        <Button
          disabled={auth.isDisable}
          onClick={props.onClick}
          sx={{
            color: '#282828',
            font: 'normal normal bold 16px/23px Noto Sans JP',
            textAlign: 'center',
            backgroundColor: '#FFF16F',
            '&:hover': {
              color: '#282828',
              backgroundColor: '#FFF16F',
              opacity: 0.8,
            },
            boxShadow: '0px 2px 2px #00000014',
            height: '37px',
            width: '208px',
            borderRadius: '6px',
          }}
        >
          {props.title}
        </Button>
      </Box>
    </>
  )
}
